<template>
  <div class="app header-section">
    <div class="dmRespRow">
      <div class="dmRespCol large-12 medium-12 small-12">
        <SearchResult :token="publicToken" :requestParams="requestParams" :widgetConfig="widgetConfig" v-if="publicToken"/>
      </div>
    </div>
  </div>
</template>

<script>
import SearchResult from './components/search-result.vue';
import {store} from './services/store.js';

export default {
  name: 'App',
  props: ['element','widgetConfig'],
  data() {
    return{
      publicToken : undefined,
      requestParams: store.requestParams,
      coreApiUrl : store.coreApiUrl,
      language: this.widgetConfig?.locale || 'en',
    }
  },
  components: {
    SearchResult
  },
  created() {
    store.$on('widgetConfigSet', () => {
      // this.widgetConfig = store.widgetConfig;
      this.fetchLocalTranslations(this.language);
    });
  },
  mounted() {
    this.getPublicToken();
    this.requestParams.iBusinessId = this.widgetConfig?.iBusinessId;
    let list =new URL(window.location.href);
    if(list.search.includes('key=')){
      store.requestParams.searchValue = decodeURI(list.search.split('key=')[1]);
    }
  },
  methods: {
    getPublicToken() {
      let tempToken = this.getWithExpiry('authKey');
      if(tempToken){
        this.publicToken = tempToken;
        store.setToken(this.publicToken);
        store.setWidgetConfig(this.widgetConfig);
        return;
      }
      let apiUrl = "https://auth.1-retailgear.org/api/v1/web/public-token"
      this.axios.get(apiUrl).then((response) => {
        this.publicToken = response.data.data // for all requests
        store.setToken(this.publicToken);
        store.setWidgetConfig(this.widgetConfig);
        this.setWithExpiry('authKey', this.publicToken);
      })
    },

    setWithExpiry(key, value) {
      const now = new Date()
      // `item` is an object which contains the original value
      // as well as the time when it's supposed to expire
      const item = {
        value: value,
        expiry: now.setDate(now.getDate() + 3),
      }
      localStorage.setItem(key, JSON.stringify(item))
    },

		getWithExpiry(key) {
      const itemStr = localStorage.getItem(key)
      // if the item doesn't exist, return null
      if (!itemStr) {
        return null
      }
      const item = JSON.parse(itemStr)
      // compare the expiry time of the item with the current time
      if (new Date() > item.expiry) {
        // If the item is expired, delete the item from storage
        // and return null
        localStorage.removeItem(key)
        return null
      }
      return item.value
    },
    fetchLocalTranslations(lang){
      let headers = { headers: { Authorization: this.publicToken } };
      this.axios.get(`${this.coreApiUrl}/api/v1/web/translation/all/${lang.slice(0,2)}?widget='product-list'`, headers).then((result) => {
        if(result?.data?.data?.length > 0){
          let localTranslation = {};
          localTranslation[lang] = Object.assign({}, ...result.data.data);
          this.$translate.setLocales(localTranslation);
          this.$translate.setLang(lang);
        } 
      })
    }
  }
}
</script>

<style lang="scss">
@import "~@storefront-ui/vue/styles";

::-webkit-scrollbar {
  width: 0.7em;
}
 
::-webkit-scrollbar-track {
  -webkit-box-shadow: inset 0 0 6px rgba(0,0,0,0.3);
}
 
::-webkit-scrollbar-thumb {
  background-color: darkgrey;
  outline: 1px solid slategrey;
  border-radius: 5px;
}
.app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
  margin-top: 10px;
  --product-card-add-button-right: 0.2rem;
  --product-card-add-button-bottom: -1rem;
  --product-card-badge-top: -10px;
  --product-card-badge-left: -10px;
  --badge-padding: 2px 5px;
  --badge-border-radius: 5px;
  --price-old-margin: auto 5px;
  .dmRespRow{
    padding: 0 !important;
  }
  .products__product-card{
    --product-card-max-width: 250px !important;
  }
  @include for-mobile {
    --sidebar-z-index: 999;
    .products__product-card{
      --product-card-max-width: 42vw !important;
    }
    .sf-product-card__image-wrapper{
      max-height: 70vw !important;
    }
    .sf-image, .sf-image--placeholder{
      max-width: 100%;
      max-height: 200px;
    }
    .sf-accordion-item__header{
      width: 95vw !important;
      justify-content: space-between;
      margin: 10px !important;
      padding: 10px 5px !important;
      border-bottom: 1px solid var(--c-light);
      &.is-open{
        color: var(--accordion-item-header-color);
      }
    }
    .pagination-section{
      justify-content: center;
    }
  }
  .notification-toaster{
    top: 80px;
    right: 20px;
    padding: 1rem 2rem;
    --notification-max-width: 300px;
    position: fixed;
    -webkit-transition: opacity 1s ease-in-out;
    -moz-transition: opacity 1s ease-in-out;
    -ms-transition: opacity 1s ease-in-out;
    -o-transition: opacity 1s ease-in-out;
    opacity: 1;
    z-index: 1000;
    .sf-icon{
      margin-right: 10px;
    }
  }
  .notification-toaster.hide-toaster{
    opacity: 0;
  }
  .sf-pagination__item{
    --pagination-item-height : 25px;
    padding: 0 10px;
    --pagination-item-color: var(--c-black);
    border-radius: 5px;
    &.prev, &.next {
      .sf-button--pure{
        margin-top: 3px;
      }
    }
    &.sf-button--pure{
      border: 1px solid var(--_c-gray-primary-lighten);
    }
    &.current{
      background-color: var(--_c-gray-primary-lighten) !important;
      color: var(--c-white) !important;
    } 
  }
  .sf-button.dmWidget{
    width: 100%!important;
  }
}
</style>
